export default "__VITE_ASSET__DXySGqbW__"